import { render, staticRenderFns } from "./InStoreAgingReport.vue?vue&type=template&id=954dac46&scoped=true&"
import script from "./InStoreAgingReport.vue?vue&type=script&lang=js&"
export * from "./InStoreAgingReport.vue?vue&type=script&lang=js&"
import style0 from "./InStoreAgingReport.vue?vue&type=style&index=0&id=954dac46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "954dac46",
  null
  
)

export default component.exports